export enum Paths {
  IS_FOLLOWING_OVERVIEW = '/news/selections/following',
  RECOMMENDATIONS_OVERVIEW = '/news/selections/following/recommendations',
  NEWSLETTER_SETTINGS = '/settings/notifications/email/network/news',
}

export const FOLLOWING_OVERVIEW_TAB = (tab: string): string =>
  `/news/selections/following?tab=${tab}`;
